import {
	LocalPhone,
	Print,
	CalendarToday,
	Person,
	Cake,
	Favorite,
	Healing,
	Assignment,
	Schedule,
	Info,
} from "@mui/icons-material";
import {
	Box,
	Button,
	Chip,
	Divider,
	IconButton,
	Paper,
	Tooltip,
	Typography,
	Zoom,
} from "@mui/material";
import { useState } from "react";

const PhotoPrescriptionPreview = ({ prescription }) => {
	const [isExpanded, setIsExpanded] = useState(false);

	const handlePrint = () => {
		const newWindow = window.open("", "", "width=800,height=600");
		newWindow.document.write(`
      <html>
        <head>
          <title>স্বাস্থ্য উপদেশ</title>
          <style>
            body { 
              font-family: Arial, sans-serif; 
              padding: 20px;
              max-width: 800px;
              margin: 0 auto;
              color: #333;
            }
            .header {
              text-align: center;
              margin-bottom: 20px;
              padding-bottom: 10px;
              border-bottom: 2px solid #3b82f6;
            }
            h2 { 
              color: #1e40af; 
              margin-bottom: 5px;
            }
            .patient-info {
              display: flex;
              justify-content: space-between;
              margin-bottom: 20px;
              background: #f0f9ff;
              padding: 10px;
              border-radius: 5px;
            }
            .section {
              margin-bottom: 20px;
            }
            .section-title {
              color: #3b82f6;
              border-bottom: 1px solid #ddd;
              padding-bottom: 5px;
              margin-bottom: 10px;
            }
            ul { 
              list-style-type: disc; 
              margin-left: 20px; 
              padding-left: 15px;
            }
            li {
              padding: 5px 0;
            }
            .footer {
              margin-top: 30px;
              padding-top: 10px;
              border-top: 1px solid #ddd;
              font-style: italic;
              font-size: 12px;
              color: #666;
            }
            .note {
              background: #f9f9f9;
              padding: 10px;
              border-left: 3px solid #3b82f6;
              margin-top: 20px;
            }
            .medication {
              margin-bottom: 15px;
              padding: 10px;
              border-left: 3px solid #3b82f6;
              background: #f0f9ff;
            }
            .medication h4 {
              margin-top: 0;
              color: #1e40af;
            }
            .doctor-info {
              display: flex;
              justify-content: space-between;
              margin-bottom: 15px;
              font-style: italic;
            }
          </style>
        </head>
        <body>
          <div class="header">
            <h2>${prescription?.organization_name || "স্বাস্থ্য উপদেশ"}</h2>
            <p>তারিখ: ${new Date(
				prescription?.creation_date || new Date()
			).toLocaleDateString()}</p>
          </div>
          
          <div class="doctor-info">
            <div>
              <strong>ডাক্তার:</strong> ${prescription?.doctor_name || "N/A"}
            </div>
          </div>
          
          <div class="patient-info">
            <div>
              <strong>নাম:</strong> ${prescription?.name || "N/A"}
            </div>
            <div>
              <strong>বয়স:</strong> ${prescription?.age || "N/A"} বছর
            </div>
          </div>
          
          ${
				prescription?.cc_list &&
				Object.keys(JSON.parse(prescription.cc_list || "{}")).length > 0
					? `
            <div class="section">
              <h3 class="section-title">মূল সমস্যা:</h3>
              <ul>
                ${Object.values(JSON.parse(prescription.cc_list || "{}"))
					.map((cc) => `<li>${cc}</li>`)
					.join("")}
              </ul>
            </div>
          `
					: ""
			}
          
          ${
				prescription?.vitals
					? `
            <div class="section">
              <h3 class="section-title">গুরুত্বপূর্ণ:</h3>
              <ul>
                ${
					JSON.parse(prescription?.vitals || "{}").BP
						? `<li>রক্তচাপ: ${
								JSON.parse(prescription?.vitals).BP
						  }</li>`
						: ""
				}
                ${
					JSON.parse(prescription?.vitals || "{}").DM
						? `<li>DM: ${JSON.parse(prescription?.vitals).DM}</li>`
						: ""
				}
                ${
					JSON.parse(prescription?.vitals || "{}").HTN
						? `<li>HTN: ${
								JSON.parse(prescription?.vitals).HTN
						  }</li>`
						: ""
				}
                ${
					JSON.parse(prescription?.vitals || "{}").pulse
						? `<li>Pulse: ${
								JSON.parse(prescription?.vitals).pulse
						  }</li>`
						: ""
				}
                ${
					JSON.parse(prescription?.vitals || "{}").weight
						? `<li>Weight: ${
								JSON.parse(prescription?.vitals).weight
						  } kg</li>`
						: ""
				}
              </ul>
            </div>
          `
					: ""
			}
          
          ${
				prescription?.medicine_list &&
				Object.keys(JSON.parse(prescription.medicine_list || "{}"))
					.length > 0
					? `
            <div class="section">
              <h3 class="section-title">ঔষধ সমূহ:</h3>
              <ul>
                ${Object.values(JSON.parse(prescription.medicine_list || "{}"))
					.map((medicine) => `<li>${medicine}</li>`)
					.join("")}
              </ul>
            </div>
          `
					: ""
			}
          
          ${
				prescription?.advices_list &&
				Object.keys(JSON.parse(prescription.advices_list || "{}"))
					.length > 0
					? `
            <div class="section">
              <h3 class="section-title">পরামর্শ:</h3>
              <ul>
                ${Object.values(JSON.parse(prescription.advices_list || "{}"))
					.map((advice) => `<li>${advice}</li>`)
					.join("")}
              </ul>
            </div>
          `
					: ""
			}
          
          ${
				prescription?.followup
					? `
            <div class="section">
              <h3 class="section-title">Follow-up:</h3>
              <p>${prescription?.followup}</p>
            </div>
          `
					: ""
			}
          
          ${
				prescription?.medicine_usage_list &&
				JSON.parse(prescription?.medicine_usage_list || "[]").length > 0
					? `
            <div class="section">
              <h3 class="section-title">ঔষুধের ব্যবহার:</h3>
              ${JSON.parse(prescription?.medicine_usage_list || "[]")
					.map(
						(usage, index) => `
                <div class="medication">
                  <h4>${index + 1}. ${usage.drugname}</h4>
                  <ul>
                    <li><strong>ব্যবহারের সময়কাল:</strong> ${
						usage.medicine_usage?.duration || "N/A"
					}</li>
                    <li><strong>ঔষধের নাম:</strong> ${
						usage.medicine_usage?.medicine_name || "N/A"
					}</li>
                    <li><strong>শারীরবৃত্তীয় প্রভাব:</strong> ${
						usage.medicine_usage?.physiological_effect || "N/A"
					}</li>
                    <li><strong>প্রাথমিক ব্যবহার:</strong> ${
						usage.medicine_usage?.primary_usage || "N/A"
					}</li>
                    <li><strong>সাধারণ ডোজ:</strong> ${
						usage.medicine_usage?.typical_dose || "N/A"
					}</li>
                    <li><strong>খাবারের সাথে গ্রহণ:</strong> ${
						usage.medicine_usage?.with_meal || "N/A"
					}</li>
                  </ul>
                </div>
              `
					)
					.join("")}
            </div>
          `
					: ""
			}
          

          <div class="footer">
            <p>Org Phone: ${prescription?.organization_phone || "N/A"}</p>
            <p>${
				prescription?.organization_name || ""
			} &copy; ${new Date().getFullYear()}</p>
          </div>
        </body>
      </html>
    `);

		newWindow.document.close();
		newWindow.focus();
		setTimeout(() => {
			newWindow.print();
			newWindow.close();
		}, 500);
	};

	// Function to safely parse JSON with a fallback
	const safeParseJSON = (jsonString, fallback) => {
		try {
			return jsonString ? JSON.parse(jsonString) : fallback;
		} catch (error) {
			console.error("Error parsing JSON:", error);
			return fallback;
		}
	};

	const vitals = safeParseJSON(prescription?.vitals, {});
	const ccList = safeParseJSON(prescription?.cc_list, {});
	const medicineList = safeParseJSON(prescription?.medicine_list, {});
	const advicesList = safeParseJSON(prescription?.advices_list, {});
	const medicineUsageList = safeParseJSON(
		prescription?.medicine_usage_list,
		[]
	);

	return (
		<Paper className="max-w-2xl mx-auto bg-white rounded-lg shadow-lg border border-blue-100 overflow-hidden">
			{/* Header Section */}
			<Box className="bg-gradient-to-r from-blue-600 to-blue-800 p-4 text-white">
				<Typography variant="h4" className="font-bold text-center">
					{prescription?.organization_name || "স্বাস্থ্য উপদেশ"}
				</Typography>
				<Box className="flex justify-between items-center mt-2">
					<Box className="flex items-center">
						<CalendarToday fontSize="small" className="mr-1" />
						<Typography variant="body2">
							{new Date(
								prescription?.creation_date || new Date()
							).toLocaleDateString()}
						</Typography>
					</Box>
					<Box className="flex gap-2">
						<Tooltip title="Print Prescription">
							<IconButton
								onClick={handlePrint}
								size="small"
								className="bg-white text-blue-800"
							>
								<Print />
							</IconButton>
						</Tooltip>
					</Box>
				</Box>
			</Box>

			{/* Doctor Info */}
			<Box className="bg-blue-50 px-6 py-2 flex items-center">
				<Person className="text-blue-600 mr-2" />
				<Typography variant="subtitle1" className="font-medium">
					ডাক্তার: {prescription?.doctor_name || "N/A"}
				</Typography>
			</Box>

			{/* Patient Information */}
			<Box className="px-6 py-4 bg-white">
				<Box className="flex flex-wrap gap-4 justify-between mb-4 p-3 bg-blue-50 rounded-lg">
					<Box className="flex items-center">
						<Person className="text-blue-600 mr-2" />
						<Typography>
							<span className="font-semibold">নাম:</span>{" "}
							{prescription?.name || "N/A"}
						</Typography>
					</Box>
					<Box className="flex items-center">
						<Cake className="text-blue-600 mr-2" />
						<Typography>
							<span className="font-semibold">বয়স:</span>{" "}
							{prescription?.age || "N/A"} বছর
						</Typography>
					</Box>
				</Box>

				{/* Chief Complaints */}
				{Object.keys(ccList).length > 0 && (
					<Box className="mb-4">
						<Box className="flex items-center mb-2">
							<Info className="text-blue-600 mr-2" />
							<Typography
								variant="h6"
								className="font-semibold text-blue-800"
							>
								মূল সমস্যা
							</Typography>
						</Box>
						<Divider className="mb-2" />
						<ul className="list-disc ml-8">
							{Object.values(ccList).map((cc, index) => (
								<li
									key={index}
									className="py-1 text-gray-800"
								>
									{cc}
								</li>
							))}
						</ul>
					</Box>
				)}

				{/* Vitals */}
				{Object.keys(vitals).length > 0 && (
					<Box className="mb-4">
						<Box className="flex items-center mb-2">
							<Favorite className="text-blue-600 mr-2" />
							<Typography
								variant="h6"
								className="font-semibold text-blue-800"
							>
								গুরুত্বপূর্ণ
							</Typography>
						</Box>
						<Divider className="mb-2" />
						<Box className="flex flex-wrap gap-2 mt-2">
							{vitals.BP && (
								<Chip
									label={`রক্তচাপ: ${vitals.BP}`}
									className="bg-red-50 text-red-800"
								/>
							)}
							{vitals.DM && (
								<Chip
									label={`DM: ${vitals.DM}`}
									className="bg-orange-50 text-orange-800"
								/>
							)}
							{vitals.HTN && (
								<Chip
									label={`HTN: ${vitals.HTN}`}
									className="bg-purple-50 text-purple-800"
								/>
							)}
							{vitals.pulse && (
								<Chip
									label={`Pulse: ${vitals.pulse}`}
									className="bg-blue-50 text-blue-800"
								/>
							)}
							{vitals.weight && (
								<Chip
									label={`Weight: ${vitals.weight} kg`}
									className="bg-green-50 text-green-800"
								/>
							)}
						</Box>
					</Box>
				)}

				{/* Medicines */}
				{Object.keys(medicineList).length > 0 && (
					<Box className="mb-4">
						<Box className="flex items-center mb-2">
							<Healing className="text-blue-600 mr-2" />
							<Typography
								variant="h6"
								className="font-semibold text-blue-800"
							>
								ঔষধ সমূহ
							</Typography>
						</Box>
						<Divider className="mb-2" />
						<ul className="list-disc ml-8">
							{Object.values(medicineList).map(
								(medicine, index) => (
									<li
										key={index}
										className="py-1 text-gray-800"
									>
										{medicine}
									</li>
								)
							)}
						</ul>
					</Box>
				)}

				{/* Advice */}
				{Object.keys(advicesList).length > 0 && (
					<Box className="mb-4">
						<Box className="flex items-center mb-2">
							<Assignment className="text-blue-600 mr-2" />
							<Typography
								variant="h6"
								className="font-semibold text-blue-800"
							>
								পরামর্শ
							</Typography>
						</Box>
						<Divider className="mb-2" />
						<ul className="list-disc ml-8">
							{Object.values(advicesList).map(
								(advice, index) => (
									<li
										key={index}
										className="py-1 text-gray-800"
									>
										{advice}
									</li>
								)
							)}
						</ul>
					</Box>
				)}

				{/* Follow-up */}
				{prescription?.followup && (
					<Box className="mb-4">
						<Box className="flex items-center mb-2">
							<Schedule className="text-blue-600 mr-2" />
							<Typography
								variant="h6"
								className="font-semibold text-blue-800"
							>
								Follow-up
							</Typography>
						</Box>
						<Divider className="mb-2" />
						<Typography className="py-1 text-gray-800 ml-8">
							{prescription.followup}
						</Typography>
					</Box>
				)}

				{/* Medicine Usage - Toggle Expandable */}
				{medicineUsageList.length > 0 && (
					<Box className="mb-4">
						<Button
							fullWidth
							variant="contained"
							color="primary"
							onClick={() => setIsExpanded(!isExpanded)}
							className="text-left mb-2"
							sx={{
								justifyContent: "flex-start",
								backgroundColor: "#3b82f6",
								":hover": {
									backgroundColor: "#2563eb",
								},
							}}
						>
							<Box className="flex items-center">
								<Info className="mr-2" />
								<Typography>
									{isExpanded ? "Hide" : "Show"} ঔষুধের
									ব্যবহার বিস্তারিত
								</Typography>
							</Box>
						</Button>

						{isExpanded && (
							<Box className="mt-2 bg-blue-50 p-4 rounded-lg">
								{medicineUsageList.map((usage, index) => (
									<Box
										key={index}
										className={`mb-4 p-4 bg-white rounded-lg shadow-sm border-l-4 border-blue-500 ${
											index !==
											medicineUsageList.length - 1
												? "mb-4"
												: ""
										}`}
									>
										<Typography
											variant="h6"
											className="font-semibold text-blue-800 mb-2"
										>
											{index + 1}. {usage.drugname}
										</Typography>
										<Box className="grid grid-cols-1 gap-x-4 gap-y-2">
											<Box className="flex items-start">
												<Typography
													variant="body2"
													className="font-medium min-w-32 text-gray-600"
												>
													ব্যবহারের সময়কাল:
												</Typography>
												<Typography
													variant="body2"
													className="text-gray-800"
												>
													{usage.medicine_usage
														?.duration || "N/A"}
												</Typography>
											</Box>
											<Box className="flex items-start">
												<Typography
													variant="body2"
													className="font-medium min-w-32 text-gray-600"
												>
													ঔষধের নাম:
												</Typography>
												<Typography
													variant="body2"
													className="text-gray-800"
												>
													{usage.medicine_usage
														?.medicine_name ||
														"N/A"}
												</Typography>
											</Box>
											<Box className="flex items-start">
												<Typography
													variant="body2"
													className="font-medium min-w-32 text-gray-600"
												>
													শারীরবৃত্তীয় প্রভাব:
												</Typography>
												<Typography
													variant="body2"
													className="text-gray-800"
												>
													{usage.medicine_usage
														?.physiological_effect ||
														"N/A"}
												</Typography>
											</Box>
											<Box className="flex items-start">
												<Typography
													variant="body2"
													className="font-medium min-w-32 text-gray-600"
												>
													প্রাথমিক ব্যবহার:
												</Typography>
												<Typography
													variant="body2"
													className="text-gray-800"
												>
													{usage.medicine_usage
														?.primary_usage ||
														"N/A"}
												</Typography>
											</Box>
											<Box className="flex items-start">
												<Typography
													variant="body2"
													className="font-medium min-w-32 text-gray-600"
												>
													সাধারণ ডোজ:
												</Typography>
												<Typography
													variant="body2"
													className="text-gray-800"
												>
													{usage.medicine_usage
														?.typical_dose ||
														"N/A"}
												</Typography>
											</Box>
											<Box className="flex items-start">
												<Typography
													variant="body2"
													className="font-medium min-w-32 text-gray-600"
												>
													খাবারের সাথে গ্রহণ:
												</Typography>
												<Typography
													variant="body2"
													className="text-gray-800"
												>
													{usage.medicine_usage
														?.with_meal ||
														"N/A"}
												</Typography>
											</Box>
										</Box>
									</Box>
								))}
							</Box>
						)}
					</Box>
				)}

				{/* Warning Note */}
				{/* <Box className="p-3 border-l-4 border-yellow-500 bg-yellow-50 rounded-r mb-4">
					<Typography variant="body2" className="text-yellow-800">
						<sup>1.</sup> এটি একটি প্রাথমিক রূপরেখা। রেজিস্টার্ড
						ডাক্তারের পরামর্শ নিয়ে ওষুধ সেবন করুন।
					</Typography>
				</Box> */}
			</Box>

			{/* Footer Section */}
			<Box className="bg-red-100 p-3 flex justify-between items-center">
				<Button
					variant="contained"
					startIcon={<Print />}
					onClick={handlePrint}
					className="bg-blue-600 hover:bg-blue-700"
				>
					প্রিন্ট করুন
				</Button>
				<Box className="flex items-center text-red-800">
					<LocalPhone className="mr-1" fontSize="small" />
					<Typography variant="body2" className="font-semibold">
					Org Phone: {prescription?.organization_phone || "N/A"}
					</Typography>
				</Box>
			</Box>
		</Paper>		
	);
};

export default PhotoPrescriptionPreview;
